import z from 'zod';
import { ApiClient } from './client';

const documentSchema = z.object({
  id: z.number(),
  type: z.string(),
  version: z.string(),
  title: z.string(),
  content_url: z.string().url(),
  summary: z.string(),
  effective_date: z.string().datetime(),
  requires_acceptance: z.boolean(),
  is_active: z.boolean(),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

const schema = z.object({
  requires_action: z.boolean(),
  documents_requiring_acceptance: z.array(documentSchema),
});

export type LegalDocument = z.infer<typeof documentSchema>;

export type AcceptedUserAgreement = z.infer<typeof schema>;

export class UserAgreementClient extends ApiClient {
  /**
   * Gets status for user agreements
   * @throws {Error} If the API request fails
   */
  status = async () => {
    return schema.safeParse(await this._get<AcceptedUserAgreement>(`user-agreements/status/`));
  };

  /**
   * Accept a legal document
   * @throws {Error} If the API request fails
   */
  accept = async (documentIds: number[]) => {
    return schema.safeParse(
      await this._post<AcceptedUserAgreement>(`user-agreements/accept/`, {
        document_ids: documentIds,
      }),
    );
  };
}
